import React from 'react'
import AdmStudentFee from '../../components/AdminTabs/AdminStudentFee/AdmStudentFee'

const StudentFee = () => {
  return (
    <div>
      <AdmStudentFee/>
    </div>
  )
}

export default StudentFee
